import styled from 'styled-components';
import { Button } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const DetailsButton = styled(Button)`
  flex: 1;
  height: 32px;
  border: 1px solid #fa8c16;
  border-radius: 4px;
  color: #fa8c16;
  font-size: 12px;
  font-weight: 500;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  .anticon {
    margin-left: 0 !important;
  }

  &:hover {
    border-color: #fa8c16;
    color: #fa8c16;
  }

  @media (max-width: ${BREAKPOINTS.desktop}) {
    min-width: 32px;
    padding: 0 8px;

    .button-text-desktop {
      display: none;
    }

    .button-text-mobile {
      display: inline;
    }
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    .button-text-desktop {
      display: inline;
    }

    .button-text-mobile {
      display: none;
    }
  }
`;
